import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

export default function BlogSection() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBlogs = async () => {
            setLoading(true);

            try {
                const res = await axios.get("https://jumeiradiscounthotels.com/api/blogs");
                setBlogs(res.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    return (
        <section className="relative overflow-hidden bg-slate-50 py-16 sm:py-20 lg:py-24">

            {/* Background Decorations */}
            <div className="absolute top-0 right-0 w-80 h-80 bg-[#D4A83F]/10 rounded-full blur-3xl"></div>

            <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#174B5F]/10 rounded-full blur-3xl"></div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Header */}
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">

                    <div className="max-w-3xl">

                        {/* Label */}
                        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#002B45]/5 border border-[#002B45]/10 mb-5">
                            <span className="w-2 h-2 rounded-full bg-[#D4A83F]"></span>

                            <span className="text-xs sm:text-sm font-bold tracking-wide text-[#174B5F]">
                                TRAVEL GUIDES & TIPS
                            </span>
                        </div>

                        {/* Heading */}
                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#002B45] leading-tight">
                            Inspiration for
                            <span className="text-[#D4A83F]"> Your Next Journey</span>
                        </h2>

                        <p className="text-slate-500 mt-4 max-w-2xl text-sm sm:text-base leading-7">
                            Discover travel inspiration, hotel guides, Dubai attractions,
                            money-saving tips and expert recommendations.
                        </p>

                    </div>

                    {/* Desktop Button */}
                    <button
                        onClick={() => navigate("/blogs")}
                        className="hidden sm:flex items-center gap-3 flex-shrink-0 px-6 py-3.5 rounded-xl bg-[#002B45] hover:bg-[#174B5F] text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                    >
                        Explore All Articles
                        <span className="text-lg">
                            →
                        </span>
                    </button>

                </div>

                {/* Loading */}
                {loading ? (
                    <div className="flex flex-col justify-center items-center py-24 gap-4">

                        <div className="w-12 h-12 rounded-full border-4 border-[#174B5F]/20 border-t-[#D4A83F] animate-spin"></div>

                        <p className="text-slate-500 text-sm">
                            Loading travel stories...
                        </p>

                    </div>
                ) : blogs.length > 0 ? (
                    <>
                        {/* Blog Grid */}
                        {/* Blog Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">

                            {blogs.slice(0, 3).map((blog) => (
                                <article
                                    key={blog.id}
                                    className="group relative bg-white rounded-3xl overflow-hidden border border-slate-200/80 shadow-[0_8px_30px_rgba(15,23,42,0.07)] hover:shadow-[0_20px_50px_rgba(15,23,42,0.14)] hover:-translate-y-1.5 transition-all duration-500"
                                >

                                    {/* Image */}
                                    <Link to={`/blogs/${blog.slug}`}>
                                        <div className="relative h-[250px] sm:h-[270px] overflow-hidden">

                                            <img
                                                src={blog.thumbnail_image}
                                                alt={blog.title}
                                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                            />

                                            {/* Overlay */}
                                            <div className="absolute inset-0 bg-gradient-to-t from-[#001925]/85 via-[#001925]/10 to-transparent"></div>

                                            {/* Category */}
                                            <div className="absolute top-5 left-5">
                                                <span className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-md text-[#002B45] px-3.5 py-2 rounded-full text-[11px] font-bold shadow-lg">
                                                    <span className="w-1.5 h-1.5 rounded-full bg-[#D4A83F]"></span>

                                                    {blog.category?.name || "Travel"}
                                                </span>
                                            </div>

                                            {/* Date */}
                                            <div className="absolute bottom-5 left-5">
                                                <span className="text-white/90 text-xs font-medium">
                                                    {new Date(blog.created_at).toLocaleDateString(
                                                        "en-US",
                                                        {
                                                            day: "numeric",
                                                            month: "short",
                                                            year: "numeric"
                                                        }
                                                    )}
                                                </span>
                                            </div>

                                        </div>
                                    </Link>

                                    {/* Content */}
                                    <div className="p-5 sm:p-6">

                                        {/* Title */}
                                        <Link to={`/blogs/${blog.slug}`}>
                                            <h3 className="text-xl font-extrabold text-[#002B45] leading-tight line-clamp-2 group-hover:text-[#174B5F] transition-colors duration-300">
                                                {blog.title}
                                            </h3>
                                        </Link>

                                        {/* Description */}
                                        <p className="text-slate-500 text-sm leading-6 line-clamp-3 mt-4 min-h-[72px]">
                                            {blog.excerpt}
                                        </p>

                                        {/* Divider */}
                                        <div className="border-t border-slate-100 mt-5 pt-4"></div>

                                        {/* Footer */}
                                        <div className="flex items-center justify-between">

                                            <span className="text-[11px] uppercase tracking-wider font-bold text-slate-400">
                                                Travel Guide
                                            </span>

                                            <Link
                                                to={`/blogs/${blog.slug}`}
                                                className="flex items-center gap-2 text-[#002B45] font-bold text-sm group/read"
                                            >
                                                Read

                                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#002B45] text-white group-hover/read:bg-[#D4A83F] group-hover/read:text-[#002B45] group-hover/read:translate-x-1 transition-all duration-300">
                                                    →
                                                </span>
                                            </Link>

                                        </div>

                                    </div>

                                </article>
                            ))}

                        </div>

                        {/* Mobile Button */}
                        <div className="mt-10 sm:hidden">
                            <button
                                onClick={() => navigate("/blogs")}
                                className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F] text-white px-5 py-3.5 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                            >
                                Explore All Articles
                                <span>→</span>
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="text-center py-16">
                        <p className="text-slate-500">
                            No blogs found
                        </p>
                    </div>
                )}

            </div>
        </section>
    );
}